const authorityMenus = {
  state: {
    authorityMenus: null
  },
  actions: {
    async initAuthorityMenus (context, basicInfo) {
      context.state.authorityMenus = basicInfo
    }
  }
}

export default authorityMenus
